import { jsx as p } from "react/jsx-runtime";
import { L as d } from "../../../../../link-DrLjFGsB.js";
const c = ({
  href: o,
  openNewTab: s,
  alternativeAction: m,
  onAlternativeAction: r
}) => o ? /* @__PURE__ */ p(d, { href: o, color: "secondary", ...s && { target: "_blank", rel: "noopener" }, children: m }) : /* @__PURE__ */ p("button", { onClick: () => r == null ? void 0 : r(), children: m });
export {
  c as AlternativeAction
};
